export const getTemplateDraftStoreKey = (id?: string): string => `templateDraft-${id ?? 'new'}`

/** Gate localStorage writes so a prior template's in-memory state cannot bleed into a new id's draft key. */
export const canPersistTemplateDraft = (
  initialLoadComplete: boolean,
  loadedTemplateId: string | undefined,
  currentId: string | undefined
): boolean => initialLoadComplete && loadedTemplateId === currentId
